<div class="jumbotron">
    <h1>{{ i18n._116_MY_COMPAS_PROFILE | translate }}</h1>
    <cmps-client-logo></cmps-client-logo>
</div>
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12 col-md-4">
            <div
                class="card"
                role="region"
                aria-labelledby="profileUserHeader"
            >
                <div
                    class="card-header"
                    id="profileUserHeader"
                    role="heading"
                    aria-level="2"
                >
                    {{ i18n._119_USER_PROFILE | translate }}
                </div>
                <div class="card-body">
                    <p>
                        <cmps-auth-profile-picture-btn
                            [(photoUrl)]="photoUrl"
                            [editable]="true"
                            [ariaLabel]="'Profile Picture'"
                            (photoChange)="onPhotoChange($event)"
                        ></cmps-auth-profile-picture-btn>
                    </p>
                    <div class="h6">{{ i18n._53_NAME | translate }}</div>
                    <p>
                        {{ user.firstName }} {{ user.middleName }}
                        {{ user.lastName }}
                    </p>
                    <div class="h6">{{ i18n._72_USERNAME | translate }}</div>
                    <p>
                        <cmps-wait-status
                            [background]="false"
                            [center]="false"
                            *ngIf="hasPendingSecurityInfo"
                        ></cmps-wait-status>
                        <ng-container *ngIf="!hasPendingSecurityInfo">{{
                            user.securityInfo?.username
                        }}</ng-container>
                    </p>
                    <div class="h6">{{ i18n._38_EMAIL | translate }}</div>
                    <p>{{ user.email }}</p>
                    <div class="h6">{{ i18n._45_LANGUAGE | translate }}</div>
                    <cmps-wait-status
                        [background]="false"
                        [center]="false"
                        *ngIf="hasPendingLanguages"
                    ></cmps-wait-status>
                    <ng-select
                        [options]="languageOpts"
                        [disabled]="!canSelectLanguage"
                        [ngModel]="
                            user.languageId == null ? null : [user.languageId]
                        "
                        (ngModelChange)="onLanguageSelect($event)"
                        *ngIf="!hasPendingLanguages"
                    ></ng-select>
                    <ng-container *ngIf="canSelectLanguage && tokenLangDiffers">
                        <div
                            class="alert alert-warning mt-1 mb-0"
                            role="alert"
                        >
                            {{
                                i18n._953_THIS_WILL_TAKE_EFFECT_THE_NEXT_TIME_YOU_LOGIN_
                                    | translate
                            }}
                        </div>
                    </ng-container>
                </div>
                <div
                    class="card-body"
                    *ngIf="
                        !hasSaml2AuthMethod &&
                        !hasPendingSecurityInfo &&
                        !!user.securityInfo
                    "
                >
                    <button
                        type="button"
                        class="btn btn-link d-block pr-0 pl-0"
                        aria-haspopup="true"
                        (click)="changePassword()"
                    >
                        {{ i18n._111_CHANGE_PASSWORD | translate }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-link d-block pr-0 pl-0"
                        aria-haspopup="true"
                        (click)="changeSecurityQuestion()"
                    >
                        {{ i18n._112_CHANGE_SECURITY_QUESTION | translate }}
                    </button>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-md-8">
            <div class="row">
                <div class="col-12">
                    <div
                        class="card"
                        role="region"
                        aria-labelledby="profileInfoHeader"
                    >
                        <div
                            class="card-header"
                            id="profileInfoHeader"
                            role="heading"
                            aria-level="2"
                        >
                            {{ i18n._118_USER_INFORMATION | translate }}
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="h6">
                                        {{ i18n._44_HIRE_DATE | translate }}
                                    </div>
                                    <p>
                                        {{ user.tenureDate | date: 'y-MM-dd' }}
                                    </p>
                                    <div class="h6">
                                        {{
                                            i18n._115_CURRENT_SUPERGROUP
                                                | translate
                                        }}
                                    </div>
                                    <p>{{ user.superGroup }}</p>
                                    <div class="h6">
                                        {{ i18n._114_CURRENT_ROLE | translate }}
                                    </div>
                                    <p>{{ user.role }}</p>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="h6">
                                        {{
                                            i18n._113_CURRENT_EMPLOYEE_TYPE
                                                | translate
                                        }}
                                    </div>
                                    <p>{{ user.employeeType }}</p>
                                    <div class="h6">
                                        {{
                                            i18n._117_SECURITY_GROUPS
                                                | translate
                                        }}
                                    </div>
                                    <p *ngIf="hasPendingSecurityGroups">
                                        <cmps-wait-status
                                            [background]="false"
                                            [center]="false"
                                        ></cmps-wait-status>
                                    </p>
                                    <p
                                        *ngIf="
                                            !hasPendingSecurityGroups &&
                                            (!user.securityGroups ||
                                                user.securityGroups.length ===
                                                    0)
                                        "
                                    >
                                        {{
                                            i18n._80_NO_SECURITY_GROUPS_CONFIGURED
                                                | translate
                                        }}
                                    </p>
                                    <p
                                        *ngIf="
                                            !hasPendingSecurityGroups &&
                                            !!user.securityGroups &&
                                            user.securityGroups.length !== 0
                                        "
                                    >
                                        <ng-template
                                            ngFor
                                            let-i
                                            [ngForOf]="user.securityGroups"
                                        >
                                            <span class="d-block">{{
                                                i.securityGroupId
                                                    | cmpsSelectLabel
                                                        : securityGroupOpts
                                                        : 'value'
                                                        : 'label'
                                            }}</span>
                                        </ng-template>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div>
                        <cmps-profile-hierarchy
                            [which]="'managers'"
                            [user]="user"
                        ></cmps-profile-hierarchy>
                    </div>
                </div>
                <div class="col-12">
                    <div>
                        <cmps-profile-supergroup
                            [user]="user"
                        ></cmps-profile-supergroup>
                    </div>
                </div>
                <div class="col-12">
                    <div>
                        <cmps-profile-hierarchy
                            [which]="'subordinates'"
                            [user]="user"
                        ></cmps-profile-hierarchy>
                    </div>
                </div>
                <div class="col-12">
                    <div>
                        <cmps-profile-system-id
                            [user]="user"
                        ></cmps-profile-system-id>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
